// @mui material components
import Grid from "@mui/material/Grid";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";

import SoftTypography from "components/SoftTypography";
import FilaBody from "../FilaBody";
import { valorAPesos } from "utils/truncate";

const titulos = {
  CodProv: "COD",
  Descripcion: "Nombre",
  TALLE: "Talle",
  COLOR: "Color",
  Cantidad: "Cantidad",
};

function Body({ facturaDetalle, factura }) {
  return (
    <SoftBox
      sx={{
        minWidth: "700px",
        backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 1),
        borderBottom: "1px solid",
        borderLeft: "1px solid",
      }}
    >
      <>
        <FilaBody data={titulos} factura={factura} titulos />
        {facturaDetalle?.map((producto, index) => {
          return <FilaBody data={producto} key={index} factura={factura} />;
        })}
      </>
    </SoftBox>
  );
}

Body.propTypes = {
  dataPresupuesto: PropTypes.object,
  ejemplo: PropTypes.object,
  color: PropTypes.string,
  facturaDetalle: PropTypes.array,
  factura: PropTypes.object,
};

export default Body;
